import { gql } from '@at/sauron-platform-graphql'

export const AiSearchResultsQuery = gql`
    query AiSearchQuery($query: String!, $channel: Channel!) {
        aiSearch(input: { query: $query, channel: $channel }) {
            facets {
                key
                values
            }
            message
            success
            metadata {
                cost
                tokens
            }
            searchUrl
        }
    }
`
